import React from "react";
import { Link } from "react-router-dom";

const OrderHeader = ({ permissions, onNewOrder }) => {
  return (
    <div className="card-header d-flex justify-content-between align-items-center">
      <h5 className="card-title mb-0">All Orders </h5>
      {permissions?.canAdd && (
        <Link
          to="#"
          className="d-flex align-items-center gap-2 btn btn-primary-600 radius-8"
          onClick={onNewOrder}
        >
          + New Order
        </Link>
      )}
    </div>
  );
};

export default React.memo(OrderHeader);